export default "__VITE_ASSET__950e8905__"